<template>
  <div class="content" v-if="isLoginUserPageUserWritable">
    <userTabs v-if="!presentationMode" :current="'add'" :pageUser="pageUser" />
    <p class="m-0 mt-3 mr-2 gothic" style="line-height: 160%;">
      시리얼 번호와 인증코드가 있어야 기기를 등록할 수 있습니다. 팅커블 IoT 키트 뒷면에 시리얼 번호와 인증코드가 있습니다.
    </p>
    <div class="m-0 mt-3 mr-2">
      <b-form @submit.stop.prevent class="was-validated stepForm" v-if="this.loginUser">
        <b-input-group size="sm" class="mt-2">
          <b-input-group-text slot="prepend" style="width : 150px;">
            <label for="deviceName" style="margin-bottom : 0rem">기기 이름</label>
          </b-input-group-text>
          <b-form-input  v-touch:swipe.stop id="deviceName" v-model="deviceName" v-b-tooltip.focus title="기기의 이름입니다. 최소 2글자 이상 최대 10글자입니다." v-on:keyup="enterKeyChecker" data-nextfocus="serial" minlength="2" maxlength="10" required trim/>
        </b-input-group>
        <b-input-group size="sm" class="mt-2">
          <b-input-group-text slot="prepend" style="width : 150px;">
            <label for="serial" style="margin-bottom : 0rem">시리얼 번호</label>
          </b-input-group-text>
          <b-form-input  v-touch:swipe.stop v-b-tooltip.focus title="기기의 시리얼번호는 영문대소문자로 되어있습니다. AAAA-AAAA-AAAA-AAAA와 같은 형식입니다. 대소문자는 구별합니다." v-on:keyup="this.enterKeyChecker" data-nextfocus="authCode" pattern="^[A-Za-z]{4}-[A-Za-z]{4}-[A-Za-z]{4}-[A-Za-z]{4}$" id="serial" v-model="serial" minlength="19" maxlength="19" required trim/>
        </b-input-group>
        <b-input-group size="sm" class="mt-2">
          <b-input-group-text slot="prepend" style="width : 150px;">
            <label for="authCode" style="margin-bottom : 0rem">인증 코드</label>
          </b-input-group-text>
          <b-form-input  v-touch:swipe.stop id="authCode" v-model="authCode" v-b-tooltip.focus title="기기의 인증 코드입니다.숫자로 되어있습니다. 9999-9999-9999-9999와 같은 형식입니다." pattern="^\d{4}-\d{4}-\d{4}-\d{4}$"  minlength="19" maxlength="19" required v-on:keyup="this.enterKeyChecker" data-nextfocus="addNewDevice"/>
        </b-input-group>
        <div class="mt-3 text-right">
          <b-button type="button" size="sm" class="pr-2 pl-2" @click="addNewDevice" variant="danger" id="addNewDevice">
            <b-spinner small type="grow" class="mr-1" v-if="showAddSpinner"></b-spinner>
            새 기기 등록하기
          </b-button>
        </div>
      </b-form>
    </div>


    <b-modal v-touch:swipe.stop size="lg" id="addDeviceAction"
    tabindex="-1" title="[1/3] 기기 등록하기" static header-bg-variant="success" header-text-variant="light" footer-bg-variant="light" header-class="pt-2 pb-2 pr-3 mb-1" body-class="pt-1" footer-class="pt-1 pb-1 pr-3 pl-3" content-class="border-0" button-size="sm" data-nextfocus="addDeviceDeviceName" no-close-on-backdrop no-close-on-esc no-stacking>

      <b-form @submit.stop.prevent class="was-validated stepForm" v-if="this.loginUser">
        
        <p class="m-0 mt-1 mr-2 gothic fontSize1Dot2" style="line-height: 160%;">
          기기의 이름을 정해주세요.
        </p>
        
        <b-input-group size="md" class="mt-2">
          <b-input-group-text slot="prepend" style="width : 150px;">
            <label for="addDeviceDeviceName" style="margin-bottom : 0rem">기기 이름</label>
          </b-input-group-text>
          <b-form-input  v-touch:swipe.stop id="addDeviceDeviceName" v-model="deviceName" v-b-tooltip.focus title="최소 2글자, 최대 10글자입니다." v-on:keyup="enterKeyChecker" data-nextfocus="addDeviceSerialNumber" minlength="2" maxlength="8" required trim/>
        </b-input-group>
        <p class="m-0 mt-3 mr-2 gothic fontSize1Dot2" style="line-height: 160%;">
          팅커블 IoT 키트 바닥에 있는 시리얼 번호와 인증코드를 적어주세요.
        </p>

        <b-input-group size="md" class="mt-2">
          <b-input-group-text slot="prepend" style="width : 150px;">
            <label for="addDeviceSerialNumber" style="margin-bottom : 0rem">시리얼 번호</label>
          </b-input-group-text>
          <b-form-input  v-touch:swipe.stop v-b-tooltip.focus title="영문대소문자. 대소문자 구별. AAAA-AAAA-AAAA-AAAA와 같은 형식" v-on:keyup="this.enterKeyChecker" data-nextfocus="addDeviceAuthCode" pattern="^[A-Za-z]{4}-[A-Za-z]{4}-[A-Za-z]{4}-[A-Za-z]{4}$" id="addDeviceSerialNumber" v-model="serial" minlength="19" maxlength="19" required trim/>
        </b-input-group>

        <b-input-group size="md" class="mt-2">
          <b-input-group-text slot="prepend" style="width : 150px;">
            <label for="addDeviceAuthCode" style="margin-bottom : 0rem">인증 코드</label>
          </b-input-group-text>
          <b-form-input v-touch:swipe.stop id="addDeviceAuthCode" v-model="authCode" v-b-tooltip.focus title="숫자. 9999-9999-9999-9999와 같은 형식" pattern="^\d{4}-\d{4}-\d{4}-\d{4}$"  minlength="19" maxlength="19" required v-on:keyup="this.enterKeyChecker" data-nextfocus="addDeviceAddNewDevice"/>
        </b-input-group>
      </b-form>
      <template slot="modal-footer">
          <b-button type="button" size="md" class="pr-3 pl-3 pt-1 pb-1 fontSize1Dot1" @click="addNewDevice" variant="success" id="addDeviceAddNewDevice">
            <b-spinner small type="grow" class="mr-1" v-if="showAddSpinner"></b-spinner>
            새 기기 등록하고 센서 설정으로 이동하기
          </b-button>
      </template>
    </b-modal>


</div>
</template>
<script>
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

import uiUtil from "@/mixins/util.js"
import user from "@/mixins/user.js"
import functions from "@/mixins/functions.js"

import userTabs from "@/components/user/userTabs.vue"

export default {
  name: "deviceIntro",
  mixins: [uiUtil, user, functions],
  props: {
    pageBinded: {
      type: Boolean,
      default: false
    },
    pageUser: {
      type: Object,
      default: null
    },
    uid: {
      type: String,
      default: ""
    },
    action: {
      type: String,
      default: ""
    },
    mode: {
      type: String,
      default: ""
    },
    marker: {
      type: String,
      default: ""
    },
  },
  components: {
    userTabs,
  },
  data: function() {
    return {
      deviceName: "",
      serial: "",
      authCode: "",
      showAddSpinner: false,
    }
  },

  mounted: function() {
    if(this.action == "addDevice") {
      this.showModal("addDeviceAction");
    }
  },


  methods: {

    addNewDevice: function(evt) {
      if(this.action == "addDevice" && evt.srcElement.id == "addDeviceAddNewDevice") {
        if(!window.document.getElementById('addDeviceDeviceName').checkValidity()) {
          window.document.getElementById('addDeviceDeviceName').reportValidity()
          return false
        }
        if(!window.document.getElementById('addDeviceSerialNumber').checkValidity()) {
          window.document.getElementById('addDeviceSerialNumber').reportValidity()
          return false
        }
        if(!window.document.getElementById('addDeviceAuthCode').checkValidity()) {
          window.document.getElementById('addDeviceAuthCode').reportValidity()
          return false
        }
      }
      else {
        if(!window.document.getElementById('deviceName').checkValidity()) {
          window.document.getElementById('deviceName').reportValidity()
          return false
        }
        if(!window.document.getElementById('serial').checkValidity()) {
          window.document.getElementById('serial').reportValidity()
          return false
        }
        if(!window.document.getElementById('authCode').checkValidity()) {
          window.document.getElementById('authCode').reportValidity()
          return false
        }
      }

      evt.srcElement.disabled = "disabled"
      this.showAddSpinner = true

      this.postJSONWithAuth(this.functionsServer + "/app/addDevice", {
        deviceName: this.deviceName,
        serial: this.serial,
        authCode: this.authCode,
      })
      .then(result=> {
        evt.srcElement.disabled = ""
        this.showAddSpinner = false
        if(result.status != 200) {
          this.makeToast("danger", "기기를 추가하지 못했습니다.", "상태코드 " + result.status + ", 상태 메시지 " + result.statusText +"인 에러가 발생해서 기기를 추가하지 못했습니다.")
        }
        else {
          if(result.data.success) {
            if(this.action == "addDevice") {
              this.$parent.$parent.makeToast("success", "기기를 추가했습니다", "잠시후에 추가한 기기의 센서 설정 페이지로 이동합니다.")
            }
            else {
              this.$parent.$parent.makeToast("success", "기기를 추가했습니다", "잠시후에 추가한 기기의 상세 정보 설정 페이지로 이동합니다.")
            }
            window.setTimeout(()=> {
              this.$router.push({path: "/d/" + result.data.deviceId + "?mode=sensors&action=addSensor"})
            }, 2000)
          }
          else {
            if(result.data.error == 6) {
              this.makeToast("danger", "기기를 추가하지 못했습니다.", "이미 사용중인 시리얼 번호입니다. 에러코드:" + result.data.error)
            }
            else if(result.data.error == 5) {
              this.makeToast("danger", "기기를 추가하지 못했습니다.", "기기 생성후 시리얼 번호, 접속 코드, 기본 센서 설정 중에 에러가 발생했습니다. 에러코드:" + result.data.error)
            }
            else if(result.data.error == 4) {
              this.makeToast("danger", "기기를 추가하지 못했습니다.", "기기를 추가하는 중에 에러가 발생했습니다. 에러코드:" + result.data.error)
            }
            else if(result.data.error == 7) {
              this.makeToast("danger", "기기를 추가하지 못했습니다.", "사용자 정보를 가져와서 처리하는 중에 에러가 발생했습니다. 에러코드:" + result.data.error)
            }
            else if(result.data.error == 3) {
              this.makeToast("danger", "기기를 추가하지 못했습니다.", "인증 코드가 일치하지 않습니다. 에러코드:" + result.data.error)
            }
            else if(result.data.error == 2) {
              this.makeToast("danger", "기기를 추가하지 못했습니다.", "시리얼 번호가 없습니다. 에러코드:" + result.data.error)
            }
            else if(result.data.error == 1) {
              this.makeToast("danger", "시리얼을 확인하는 중에 에러가 발생했습니다.에러코드:" + result.data.error)
            }
          }
        }
      })
      .catch(error => {
        evt.srcElement.disabled = ""
        this.showAddSpinner = false
        this.makeToast("danger", "기기를 추가하지 못했습니다.", "서버로 요청을 보내지 못했습니다. 에러코드: 0")
      })
    },
  },
}
</script>